
const data = [
  {
    maChuongTrinh: "1238713",
    tenChuongTrinh: "CT X",
    ngayTao: "12/08/2022",
    nguoiTao: "Nguyen Van A",
    nguoiDuyet: "Nguyen Van B",
    apDungTu: "26/08/2023",
    apDungDen: "12/09/2023",
    moTa: "-",
    trangThai: "-",
  },
  {
    maChuongTrinh: "1238713",
    tenChuongTrinh: "CT X",
    ngayTao: "12/08/2022",
    nguoiTao: "Nguyen Van A",
    nguoiDuyet: "Nguyen Van B",
    apDungTu: "26/08/2023",
    apDungDen: "12/09/2023",
    moTa: "-",
    trangThai: "-",
  },
];

export {data};